<template>
	<ProjectViewPage
		v-if="projectId && currency"
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
		:currency="currency"
	/>
</template>

<script setup lang="ts">
import { useDisplayCurrency } from '@/composables';
import { type Project, type RetainerPeriod } from '@/generated/graphql';
import { computed, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

const ProjectViewPage = defineAsyncComponent(
	() => import('@/pages/projects/ProjectsViewPage.vue')
);

const route = useRoute();
const currency = useDisplayCurrency();

const projectId = computed(() =>
	Array.isArray(route.params.projectId)
		? route.params.projectId[0]
		: (route.params.projectId as Project['id'])
);

const retainerPeriodId = computed(
	() => route.query.retainerPeriodId as RetainerPeriod['id']
);
</script>
